// @flow
import localStorageWrapper from './local-storage-wrapper';

const TUTOR_PAYMENTS_AUTH = 'TUTOR_PAYMENTS_AUTH';

const expireAllCookies = () =>
  document.cookie.split(';').forEach(c => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
  });

const userAuthUtil = {
  ...localStorageWrapper(TUTOR_PAYMENTS_AUTH),
  clear: () => {
    expireAllCookies();
    localStorage.removeItem(TUTOR_PAYMENTS_AUTH);
  },
  mergeAttributes: (attributes: Object) => {
    const previousAuth: Object = localStorageWrapper(TUTOR_PAYMENTS_AUTH).get();
    localStorageWrapper(TUTOR_PAYMENTS_AUTH).set(
      JSON.stringify({
        ...previousAuth,
        attributes: { ...previousAuth.attributes, ...attributes },
      }),
    );
  },
};

export const isLoggedInTutor = () => {
  const json = userAuthUtil.get();
  return json && json.type === 'tutors';
};

export const isLoggedInPayer = () => {
  const json = userAuthUtil.get();
  return json && json.type === 'payer';
};

export const getBusiness = () => {
  const { business = { clientTermsUrl: undefined, forceAutopay: false } } = (localStorageWrapper(
    TUTOR_PAYMENTS_AUTH,
  ).get(): any);

  return business;
};

export default userAuthUtil;



// WEBPACK FOOTER //
// ./src/utils/user-auth.js